export const IS_ONLY_TESTNET_ALLOWED =
  process.env.NEXT_PUBLIC_IS_ONLY_TESTNET_ALLOWED === 'true';
